// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminFeatureFlagsPage_FeatureFlagQueryRuleFragment = { __typename?: 'FeatureFlagQueryRule', id: string, kind?: Types.FeatureFlagQueryRuleKind | null, flagQuery: string, flagVariationName: string, releaseGroup?: { __typename?: 'ReleaseGroup', id: string, name: Types.ReleaseGroupName, description?: string | null } | null };

export type AdminFeatureFlagsPage_FeatureFlagFragment = { __typename?: 'FeatureFlag', id: string, createdAt: Time, flagDescription?: string | null, flagName: string, flagStatus: Types.FeatureFlagFlagStatus, ownedBy: string, team?: Types.FeatureFlagTeam | null, group?: Types.FeatureFlagGroup | null, queryRules?: Array<(
    { __typename?: 'FeatureFlagQueryRule' }
    & AdminFeatureFlagsPage_FeatureFlagQueryRuleFragment
  )> | null };

export type AdminFeatureFlagsPage_ReleaseGroupFragment = { __typename?: 'ReleaseGroup', id: string, name: Types.ReleaseGroupName, description?: string | null, tenants?: Array<{ __typename?: 'Tenant', id: string, name: string }> | null };

export type AdminFeatureFlagsPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminFeatureFlagsPageQuery = { __typename?: 'Query', featureFlagEvaluationResult: Array<{ __typename?: 'FeatureFlagEvaluationResult', flagEvaluationResult: boolean, flagEnablementStatus: Types.FlagEnablementStatus, name: string, flag: (
      { __typename?: 'FeatureFlag' }
      & AdminFeatureFlagsPage_FeatureFlagFragment
    ) }>, releaseGroups: { __typename?: 'ReleaseGroupConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReleaseGroupEdge', node?: (
        { __typename?: 'ReleaseGroup' }
        & AdminFeatureFlagsPage_ReleaseGroupFragment
      ) | null } | null> | null } };

export type AdminFeatureFlagsPage_TenantEnablementFragment = { __typename?: 'FeatureFlagTenantEnablement', enabled: boolean, enablementStatus: Types.FlagEnablementStatus, tenant: { __typename?: 'Tenant', id: string, name: string } };

export type FeatureFlagTenantEnablementsQueryVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;


export type FeatureFlagTenantEnablementsQuery = { __typename?: 'Query', featureFlagTenantEnablements: Array<(
    { __typename?: 'FeatureFlagTenantEnablement' }
    & AdminFeatureFlagsPage_TenantEnablementFragment
  )> };

export type SetFeatureFlagStatusMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
  status: Types.FlagEnablementStatus;
  releaseGroupId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type SetFeatureFlagStatusMutation = { __typename?: 'Mutation', setFeatureFlagStatus: { __typename?: 'FeatureFlag', id: string, flagName: string, flagStatus: Types.FeatureFlagFlagStatus } };

export const Operations = {
  Query: {
    AdminFeatureFlagsPage: 'AdminFeatureFlagsPage' as const,
    FeatureFlagTenantEnablements: 'FeatureFlagTenantEnablements' as const
  },
  Mutation: {
    SetFeatureFlagStatus: 'SetFeatureFlagStatus' as const
  },
  Fragment: {
    AdminFeatureFlagsPage_FeatureFlagQueryRule: 'AdminFeatureFlagsPage_FeatureFlagQueryRule' as const,
    AdminFeatureFlagsPage_FeatureFlag: 'AdminFeatureFlagsPage_FeatureFlag' as const,
    AdminFeatureFlagsPage_ReleaseGroup: 'AdminFeatureFlagsPage_ReleaseGroup' as const,
    AdminFeatureFlagsPage_TenantEnablement: 'AdminFeatureFlagsPage_TenantEnablement' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AdminFeatureFlagsPage_FeatureFlagQueryRuleFragmentDoc = gql`
    fragment AdminFeatureFlagsPage_FeatureFlagQueryRule on FeatureFlagQueryRule {
  id
  kind
  flagQuery
  flagVariationName
  releaseGroup {
    id
    name
    description
  }
}
    `;
export const AdminFeatureFlagsPage_FeatureFlagFragmentDoc = gql`
    fragment AdminFeatureFlagsPage_FeatureFlag on FeatureFlag {
  id
  createdAt
  flagDescription
  flagName
  flagStatus
  ownedBy
  team
  group
  queryRules {
    ...AdminFeatureFlagsPage_FeatureFlagQueryRule
  }
}
    ${AdminFeatureFlagsPage_FeatureFlagQueryRuleFragmentDoc}`;
export const AdminFeatureFlagsPage_ReleaseGroupFragmentDoc = gql`
    fragment AdminFeatureFlagsPage_ReleaseGroup on ReleaseGroup {
  id
  name
  description
  tenants {
    id
    name
  }
}
    `;
export const AdminFeatureFlagsPage_TenantEnablementFragmentDoc = gql`
    fragment AdminFeatureFlagsPage_TenantEnablement on FeatureFlagTenantEnablement {
  enabled
  enablementStatus
  tenant {
    id
    name
  }
}
    `;
export const AdminFeatureFlagsPageDocument = gql`
    query AdminFeatureFlagsPage {
  featureFlagEvaluationResult {
    flagEvaluationResult
    flagEnablementStatus
    name
    flag {
      ...AdminFeatureFlagsPage_FeatureFlag
    }
  }
  releaseGroups(first: 50) {
    totalCount
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        ...AdminFeatureFlagsPage_ReleaseGroup
      }
    }
  }
}
    ${AdminFeatureFlagsPage_FeatureFlagFragmentDoc}
${AdminFeatureFlagsPage_ReleaseGroupFragmentDoc}`;

/**
 * __useAdminFeatureFlagsPageQuery__
 *
 * To run a query within a React component, call `useAdminFeatureFlagsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFeatureFlagsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFeatureFlagsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminFeatureFlagsPageQuery(baseOptions?: Apollo.QueryHookOptions<AdminFeatureFlagsPageQuery, AdminFeatureFlagsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFeatureFlagsPageQuery, AdminFeatureFlagsPageQueryVariables>(AdminFeatureFlagsPageDocument, withFetchPolicyContext(options));
      }
export function useAdminFeatureFlagsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFeatureFlagsPageQuery, AdminFeatureFlagsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFeatureFlagsPageQuery, AdminFeatureFlagsPageQueryVariables>(AdminFeatureFlagsPageDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useAdminFeatureFlagsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminFeatureFlagsPageQuery, AdminFeatureFlagsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFeatureFlagsPageQuery, AdminFeatureFlagsPageQueryVariables>(AdminFeatureFlagsPageDocument, withFetchPolicyContext(options));
        }
export type AdminFeatureFlagsPageQueryHookResult = ReturnType<typeof useAdminFeatureFlagsPageQuery>;
export type AdminFeatureFlagsPageLazyQueryHookResult = ReturnType<typeof useAdminFeatureFlagsPageLazyQuery>;
export type AdminFeatureFlagsPageSuspenseQueryHookResult = ReturnType<typeof useAdminFeatureFlagsPageSuspenseQuery>;
export type AdminFeatureFlagsPageQueryResult = Apollo.QueryResult<AdminFeatureFlagsPageQuery, AdminFeatureFlagsPageQueryVariables>;
export const FeatureFlagTenantEnablementsDocument = gql`
    query FeatureFlagTenantEnablements($name: String!) {
  featureFlagTenantEnablements(names: [$name]) {
    ...AdminFeatureFlagsPage_TenantEnablement
  }
}
    ${AdminFeatureFlagsPage_TenantEnablementFragmentDoc}`;

/**
 * __useFeatureFlagTenantEnablementsQuery__
 *
 * To run a query within a React component, call `useFeatureFlagTenantEnablementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagTenantEnablementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagTenantEnablementsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFeatureFlagTenantEnablementsQuery(baseOptions: Apollo.QueryHookOptions<FeatureFlagTenantEnablementsQuery, FeatureFlagTenantEnablementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureFlagTenantEnablementsQuery, FeatureFlagTenantEnablementsQueryVariables>(FeatureFlagTenantEnablementsDocument, withFetchPolicyContext(options));
      }
export function useFeatureFlagTenantEnablementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlagTenantEnablementsQuery, FeatureFlagTenantEnablementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureFlagTenantEnablementsQuery, FeatureFlagTenantEnablementsQueryVariables>(FeatureFlagTenantEnablementsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFeatureFlagTenantEnablementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeatureFlagTenantEnablementsQuery, FeatureFlagTenantEnablementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeatureFlagTenantEnablementsQuery, FeatureFlagTenantEnablementsQueryVariables>(FeatureFlagTenantEnablementsDocument, withFetchPolicyContext(options));
        }
export type FeatureFlagTenantEnablementsQueryHookResult = ReturnType<typeof useFeatureFlagTenantEnablementsQuery>;
export type FeatureFlagTenantEnablementsLazyQueryHookResult = ReturnType<typeof useFeatureFlagTenantEnablementsLazyQuery>;
export type FeatureFlagTenantEnablementsSuspenseQueryHookResult = ReturnType<typeof useFeatureFlagTenantEnablementsSuspenseQuery>;
export type FeatureFlagTenantEnablementsQueryResult = Apollo.QueryResult<FeatureFlagTenantEnablementsQuery, FeatureFlagTenantEnablementsQueryVariables>;
export const SetFeatureFlagStatusDocument = gql`
    mutation SetFeatureFlagStatus($name: String!, $status: FlagEnablementStatus!, $releaseGroupId: ID, $tenantId: ID) {
  setFeatureFlagStatus(
    name: $name
    status: $status
    releaseGroupId: $releaseGroupId
    tenantId: $tenantId
  ) {
    id
    flagName
    flagStatus
  }
}
    `;
export type SetFeatureFlagStatusMutationFn = Apollo.MutationFunction<SetFeatureFlagStatusMutation, SetFeatureFlagStatusMutationVariables>;

/**
 * __useSetFeatureFlagStatusMutation__
 *
 * To run a mutation, you first call `useSetFeatureFlagStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFeatureFlagStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFeatureFlagStatusMutation, { data, loading, error }] = useSetFeatureFlagStatusMutation({
 *   variables: {
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      releaseGroupId: // value for 'releaseGroupId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useSetFeatureFlagStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetFeatureFlagStatusMutation, SetFeatureFlagStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFeatureFlagStatusMutation, SetFeatureFlagStatusMutationVariables>(SetFeatureFlagStatusDocument, options);
      }
export type SetFeatureFlagStatusMutationHookResult = ReturnType<typeof useSetFeatureFlagStatusMutation>;
export type SetFeatureFlagStatusMutationResult = Apollo.MutationResult<SetFeatureFlagStatusMutation>;
export type SetFeatureFlagStatusMutationOptions = Apollo.BaseMutationOptions<SetFeatureFlagStatusMutation, SetFeatureFlagStatusMutationVariables>;